import { render } from "./audioRecorder.vue?vue&type=template&id=dc13ed3a&scoped=true"
import script from "./audioRecorder.vue?vue&type=script&lang=js"
export * from "./audioRecorder.vue?vue&type=script&lang=js"

import "./audioRecorder.vue?vue&type=style&index=0&id=dc13ed3a&scoped=true&lang=css"

import exportComponent from "D:\\phpstudy_pro\\gpt\\chatgpt-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc13ed3a"]])

export default __exports__